export class QuestionnaireDiscontinuedError extends Error {
  constructor(public readonly questionnaireId: string) {
    super('Questionnaire discontinued');
    this.name = 'QuestionnaireDiscontinuedError';
  }
}
